import { render, staticRenderFns } from "./CourseModules.vue?vue&type=template&id=166c7400&scoped=true"
import script from "./CourseModules.vue?vue&type=script&lang=js"
export * from "./CourseModules.vue?vue&type=script&lang=js"
import style0 from "./CourseModules.vue?vue&type=style&index=0&id=166c7400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c7400",
  null
  
)

export default component.exports